<script setup lang="ts">
import { ref } from 'vue'
import integralApi from '@/api/integralApi'
import { Navigation } from '@/utils/navigation'
import type { ResGetIntegralDetailItem } from '@/api/type'
import { useIntegralStoreHook } from '@/store/modules/integral'
import { useSystemConfigStoreHook } from '@/store/modules/systemConfig'
const systemConfigStore = useSystemConfigStoreHook()
const integralConsumption = ref<ResGetIntegralDetailItem[]>(useIntegralStoreHook().integralArray)
const handleReview = () => {
  Navigation.openBlank(
    systemConfigStore.systemConfig.urlFaq ||
      'https://ocn45ksak8kq.feishu.cn/wiki/EVOfwJgY4iy8OIkNKrsc2JFRn7g?from=from_copylink',
  )
}
</script>

<template>
  <div class="flex flex-col w-[236px] h-full justify-between">
    <div class="flex flex-col w-full" style="max-width: 236px">
      <div class="text-size16 font-bold text-[#000000] mb-[23px]">功能与积分消耗</div>
      <div class="overflow-y-auto max-h-[340px] scrollbar scrollbar-left">
        <div class="pl-[8px] w-full">
          <div
            class="flex flex-col mb-[12px] custom-hover-transition"
            v-for="item in integralConsumption"
            :key="item.type"
          >
            <div class="flex flex-row items-center">
              <img
                src="@/assets/icon/select.png"
                alt="bg"
                class="w-[16px] h-[16px] flex-shrink-0"
              />
              <div class="text-size14 text-[#3D3D3D] ml-[6px] break-all whitespace-normal">
                {{ item.name }}
              </div>
            </div>
            <div
              class="flex flex-col ml-[22px] text-[#AEAEB2] text-size12 break-all whitespace-normal"
            >
              {{ item.comment }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="text-size12 text-themeColor mt-[20px]" @click="handleReview">常见问题/会员订阅</div>
  </div>
</template>

<style scoped>
.scrollbar {
  scrollbar-width: thin;
  scrollbar-color: rgba(174, 174, 178, 0.5) transparent;
  -ms-overflow-style: auto;
  overflow-x: visible;
  direction: rtl;
}

.scrollbar > div {
  direction: ltr;
}

.scrollbar::-webkit-scrollbar {
  width: 1px !important;
  height: 1px !important;
  display: block !important;
  visibility: visible !important;
}

.scrollbar::-webkit-scrollbar-track {
  background: transparent !important;
  border-radius: 1px !important;
}

.scrollbar::-webkit-scrollbar-thumb {
  background-color: rgba(174, 174, 178, 0.3) !important;
  border-radius: 1px !important;
  border: none !important;
}

.custom-hover-transition {
  transition: all 0.3s ease;
  transform-origin: left center;
}

.custom-hover-transition:hover {
  transform: scale(1.05);
  opacity: 1;
}
</style>
